import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { HeroMockup } from "./HeroMockup";

export const HeroSection = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref} className="text-center space-y-8">
    <div className="space-y-4">
      <h1 className="text-3xl md:text-4xl font-display font-bold leading-tight">
        Gi barnet ditt mer mestring i hverdagen
      </h1>
      <div className="text-lg text-muted-foreground max-w-md mx-auto space-y-1">
        <p className="font-semibold text-foreground">
          Mindre konflikter om gjøremål. Mer ansvar hos barnet.
        </p>
        <p>
          Når barnet ser sin egen plan og fremgang, slipper du å være pådriver hele tiden.
        </p>
      </div>
    </div>
    <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
      <Button size="lg" asChild>
        <Link to="/register">Kom i gang gratis</Link>
      </Button>
      <Button variant="outline" size="lg" asChild>
        <Link to="/login">Logg inn</Link>
      </Button>
    </div>
    <HeroMockup />
    <div className="space-y-1">
      <p className="text-sm text-muted-foreground">
        Start gratis. Oppgrader når dere vil følge utvikling over tid.
      </p>
      <p className="text-xs text-muted-foreground/70">
        Ingen binding. Ingen kort nødvendig.
      </p>
    </div>
  </section>
));

HeroSection.displayName = "HeroSection";
